/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Preferences_Page_DescriptionInputs */

const de_notifications_preferences_page_description = /** @type {(inputs: Notifications_Preferences_Page_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hier können Sie festlegen, welche Benachrichtigungen Sie von uns erhalten möchten. Bitte beachten Sie, dass Sie sich nicht von Servicemails zu Ihrem Vertrag abmelden können. `)
};

/** @type {(inputs: Notifications_Preferences_Page_DescriptionInputs) => LocalizedString} */
const en_notifications_preferences_page_description = de_notifications_preferences_page_description;

/**

* @param {Notifications_Preferences_Page_DescriptionInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_preferences_page_description = /** @type {((inputs?: Notifications_Preferences_Page_DescriptionInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Preferences_Page_DescriptionInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_notifications_preferences_page_description(inputs)
	return en_notifications_preferences_page_description(inputs)
});